export const environment = {
    production: true,
    apiUrl: "",
    apiVersion: "1.0",
    groupName: "Klasse",
    groupsName: "",
    buildingName: "Schulhaus",
    buildingsName: "Schulhäuser",
    categories: "",
    children: "Kinder",
    firebase: {
        apiKey: "AIzaSyC9AyTNLmmvBQWhl4R5tbm8gf7a8toT6-I",
        authDomain: "schulekuenten.firebaseapp.com",
        databaseURL: "https://schulekuenten.firebaseio.com",
        projectId: "schulekuenten",
        storageBucket: "schulekuenten.appspot.com",
        messagingSenderId: "1056487896368"
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts